module.exports = __webpack_public_path__ + "img/HC1027-02.2becae19.jpg";